/*
 Copyright 2013-2019 the original author or authors from the JHipster project.
 This file is part of the JHipster project, see https://www.jhipster.tech/
 for more information.
 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at
 http://www.apache.org/licenses/LICENSE-2.0
 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
 */
import { Subscription } from 'rxjs';
import { JhiEventWithContent } from './event-with-content.model';

/**
 * An utility class to manage RX events
 */

export abstract class JhiEventManager {
  /**
   * Method to broadcast the event to observer
   */
  public abstract broadcast(event: JhiEventWithContent<any> | string): void;

  /**
   * Method to subscribe to an event with callback
   */
  public abstract subscribe(eventName: string, callback: any): Subscription;

  /**
   * Method to unsubscribe the subscription
   */
  public abstract destroy(subscriber: Subscription): void;
}
